import { useIntl } from "react-intl";
import { Link } from "react-router-dom";
import Section from "../../common/section";
import { APP_ROUTE_AUDIT_LOGS_LIST } from "../../../constants/RouteConstants";
import "../auditLogs/audit-logs.scss";
import { retentionPeriod } from "../../../helpers/AuditLogHelper";

// How long audit entries are kept, read-only: the same for every organisation
// and nothing changes it. The days come from the API (auditLogRetentionDays on
// the enterprise details). This imports the route straight from its file: the
// constants barrel loads the menus, and they load the Audit Logs page.
const AuditLogRetentionTab = ({ retentionDays, canOpenAuditLogs }) => {
  const intl = useIntl();
  const period = retentionPeriod(retentionDays, intl.formatMessage);

  return (
    <Section title="audit_logs_settings_tab" className="edexlms-page-body audit-retention">
      <p>{intl.formatMessage({ id: "audit_retention_text" }, { period })}</p>
      {canOpenAuditLogs && (
        <Link to={APP_ROUTE_AUDIT_LOGS_LIST} className="audit-open-link">
          {intl.formatMessage({ id: "audit_open_audit_logs" })}
        </Link>
      )}
    </Section>
  );
};

export default AuditLogRetentionTab;
